import axios from 'axios';

import { ANALYTICS_DETAIL, DETALIZATION_MODAL_DOWNLOAD_OPTIONS } from 'constants/detalization';
import { REGULAR_DETALIZATION_REPORT_ACTIONS } from './constants';
import { pushDetalizationAnalytics } from '../../../../utils/analytics/detalization';
import { fetchDetalizationConfirmMailData } from '../personalDataStore/actions';

// FETCH DATA ACTIONS
export const fetchRegularDetalizationReportDataStart = () => ({
  type: REGULAR_DETALIZATION_REPORT_ACTIONS.FETCH_REGULAR_DETALIZATION_REPORT_DATA,
});

export const fetchRegularDetalizationReportDataSuccess = (payload) => ({
  type: REGULAR_DETALIZATION_REPORT_ACTIONS.FETCH_REGULAR_DETALIZATION_REPORT_DATA_SUCCESS,
  payload,
});

export const fetchRegularDetalizationReportDataError = () => ({
  type: REGULAR_DETALIZATION_REPORT_ACTIONS.FETCH_REGULAR_DETALIZATION_REPORT_DATA_ERROR,
});
// SAVE DATA ACTIONS
export const saveRegularDetalizationReportDataStart = () => ({
  type: REGULAR_DETALIZATION_REPORT_ACTIONS.SAVE_REGULAR_DETALIZATION_REPORT_DATA,
});

export const saveRegularDetalizationReportDataSuccess = (payload) => ({
  type: REGULAR_DETALIZATION_REPORT_ACTIONS.SAVE_REGULAR_DETALIZATION_REPORT_DATA_SUCCESS,
  payload,
});

export const saveRegularDetalizationReportDataError = () => ({
  type: REGULAR_DETALIZATION_REPORT_ACTIONS.SAVE_REGULAR_DETALIZATION_REPORT_DATA_ERROR,
});

export const setSaveRegularDetalizationReportInitialControlsData = () => ({
  type: REGULAR_DETALIZATION_REPORT_ACTIONS.SET_SAVE_REGULAR_DETALIZATION_REPORT_INITIAL_CONTROLS_DATA,
});

export const fetchRegularDetalizationReportData = () => async (dispatch) => {
  dispatch(fetchRegularDetalizationReportDataStart());

  try {
    const { data } = await axios.get('/api/profile/detalization/detailperiodicrequest/');

    const numbers = data.numberStatus
      .filter((number) => number.available)
      .map((number) => ({
        active: number.active,
        ctn: number.ctn,
        nickname: number?.nickname,
      }));

    const isSubscriptionStatusDisable = data.status === 'disable';
    const firstDayOfMonth = 1;

    const startSubscriptionDate = isSubscriptionStatusDisable ? firstDayOfMonth : Number(data.startDate);
    const reportType = isSubscriptionStatusDisable ? DETALIZATION_MODAL_DOWNLOAD_OPTIONS.pdf : data.reportType.toUpperCase();

    dispatch(fetchDetalizationConfirmMailData(data.confirmStatus));

    dispatch(fetchRegularDetalizationReportDataSuccess({
      numbers,
      subscriptionStatus: data.status,
      reportType,
      startSubscriptionDate,
      dueSubscriptionDate: data.dueDate,
    }));
  } catch (error) {
    dispatch(fetchRegularDetalizationReportDataError(error.message));
  }
};
const updateSubscriptionUrl = '/api/profile/detalization/updatedetailperiodicrequest';
const createSubscriptionUrl = '/api/profile/detalization/createdetailperiodicrequest/';
const deleteSubscriptionUrl = '/api/profile/detalization/deletedetailperiodicrequest/';

export const saveRegularDetalizationReportData = (
  { activeNumbers, reportType, startDate },
) => async (dispatch, getState) => {
  const {
    detalizationNew:
    {
      regularDetalizationReport:
      {
        subscriptionStatus,
        numbers: initialNumbers,
      },
    },
  } = getState();

  const isDisableStatus = subscriptionStatus === 'disable';

  let url = isDisableStatus
    ? createSubscriptionUrl
    : updateSubscriptionUrl;

  const numbersSet = new Set(activeNumbers);

  const mappedNumbers = initialNumbers.map((tel) => ({
    ...tel,
    active: numbersSet.has(tel.ctn),
  }));

  const numbers = isDisableStatus ? activeNumbers : mappedNumbers;
  const status = activeNumbers.length === 0 ? 'disable' : 'active';

  try {
    dispatch(saveRegularDetalizationReportDataStart());

    let updatedData = {
      numbers,
      reportType,
      startDate,
    };

    if (activeNumbers.length === 0) {
      url = deleteSubscriptionUrl;
      updatedData = {};
    }

    const { data } = await axios.post(url, updatedData);

    if (!data.isSuccess) {
      dispatch(saveRegularDetalizationReportDataError());
    } else {
      dispatch(saveRegularDetalizationReportDataSuccess({
        subscriptionStatus: status,
        startSubscriptionDate: startDate,
        numbers: mappedNumbers,
        reportType: reportType.toUpperCase(),
      }));

      pushDetalizationAnalytics(ANALYTICS_DETAIL.SUCCESS_REGULAR_DETAIL,
        {
          period: `${data.periodStart}-${data.periodEnd}`,
          format: reportType,
          day: startDate,
          numbers,
        });
    }
  } catch (error) {
    dispatch(saveRegularDetalizationReportDataError());
  }
};
